import { Environment } from '../../config/environment';
import { Backend } from '../Backend';
import { BookmarkFilter, BookmarkID, BookmarkRibbonFilter } from './BookmarkApi.types';
import { IBookmarkElementV1, IBookmarkUpdateV1, IRibbon2Container } from '../models/AndromeTV.types';

export class BookmarkApi {
  /**
   * Retrieve the bookmark with the specified type and id
   */
  static bookmark(backend: Backend, bookmarkId: BookmarkID): Promise<IBookmarkElementV1> {
    const type = encodeURIComponent(bookmarkId.type);
    const id = encodeURIComponent(bookmarkId.id);
    const url = backend.makeUrl(`history/v1/bookmark/${type}/${id}`, {
      profileId: bookmarkId.profileId,
    });
    return backend.getJson(url, backend.bearer) as Promise<IBookmarkElementV1>;
  }

  /**
   * Create or update a bookmark
   */
  static update(backend: Backend, bookmarkId: BookmarkID, value: IBookmarkUpdateV1): Promise<unknown> {
    const type = encodeURIComponent(bookmarkId.type);
    const id = encodeURIComponent(bookmarkId.id);
    const url = backend.makeUrl(`history/v1/bookmark/${type}/${id}`, {
      profileId: bookmarkId.profileId,
    });
    return backend.putJson(url, value, backend.bearer);
  }

  /**
   * Remove a bookmark
   * @param {Backend} backend
   * @param {BookmarkID} bookmarkId
   * @returns {Promise<Response>}
   */
  static delete(backend: Backend, bookmarkId: BookmarkID): Promise<unknown> {
    const type = encodeURIComponent(bookmarkId.type);
    const id = encodeURIComponent(bookmarkId.id);
    const url = backend.makeUrl(`history/v1/bookmark/${type}/${id}`, {
      profileId: bookmarkId.profileId,
    });
    return backend.delete(url, backend.bearer);
  }

  /**
   * Retrieve a list of bookmarks
   */
  static list(backend: Backend, filter: BookmarkFilter): Promise<IBookmarkElementV1[]> {
    const url = backend.makeUrl('history/v1/bookmark', filter);
    return backend.getJson(url, backend.bearer) as Promise<IBookmarkElementV1[]>;
  }

  /**
   * Retrieve a list of bookmarks in CMS Ribbon format
   * @param {Backend} backend
   * @param {BookmarkRibbonFilter} filter
   * @returns {Promise<IRibbon2Container>}
   */
  static ribbon(backend: Backend, filter: BookmarkRibbonFilter): Promise<IRibbon2Container> {
    const queryParam = {
      platform: Environment.system,
      ...filter,
    };
    const url = backend.makeUrl('history/v2/cms/bookmark', queryParam);
    return backend.getJson(url, backend.bearer) as Promise<IRibbon2Container>;
  }
}
